import { Alert } from '@ksyos/design-system';
import { useEffect, useState } from 'react';
import type { ServiceCode } from '../../../../../../common/enums/serviceCode';
import { getServiceLabel } from '../../../../../../common/customControls/getServiceLabel';
import { getDisplayName } from '../../../../../../common/utils/getDisplayName';
import { getJson } from '../../../../../store/fetch';

interface IRequestServiceChange {
    changedByPractitioner: {
        nameFamily: string;
        nameGiven: string | null;
        nameInfix: string | null;
    };
    nextService: {
        code: ServiceCode;
        name: string;
    };
    previousService: {
        code: ServiceCode;
        name: string;
    };
}

interface IRequestServiceChangeForRequestProps {
    requestId: string;
}

export function RequestServiceChangeForRequest(props: IRequestServiceChangeForRequestProps) {
    const [requestServiceChange, setRequestServiceChange] = useState<IRequestServiceChange | undefined>();

    useEffect(() => {
        loadRequestServiceRequest();
    }, []);

    if (!requestServiceChange) {
        return null;
    }

    const previousService = getServiceLabel(
        requestServiceChange.previousService.code,
        'request',
        requestServiceChange.previousService.name
    );
    const nextService = getServiceLabel(
        requestServiceChange.nextService.code,
        'request',
        requestServiceChange.nextService.name
    );
    const changedBy = getDisplayName(requestServiceChange.changedByPractitioner);

    return (
        <Alert appearance="info">
            Het {previousService} is omgezet naar een {nextService} door {changedBy}.
        </Alert>
    );

    async function loadRequestServiceRequest() {
        const result = await getJson(`/api/requests/${props.requestId}/serviceChangeSummary`);
        setRequestServiceChange(result.json.item);
    }
}
